<template>
  <div class="data-list-container" v-cloak>
    <!-- <p>{{'2020-12-10'|dateFormatLocalization}}</p> -->

    <lead-summary v-model="maximizeCard" :module_id="1"></lead-summary>
    <vs-popup class="popup" title="Mail" :active.sync="bulkEmailModal">
      <BulkEmail
        :mail_id="mail_id"
        @mail_body="mail_body"
        v-if="bulkEmailModal"
      >
      </BulkEmail>
    </vs-popup>

    <vs-popup
      class="popup"
      title="Column Rearrangement"
      :active.sync="columnRearrangementModal"
    >
      <RearrangeManagement
        v-if="columnRearrangementModal"
        moduleProps="Leads"
        @closeRearrangementModal="closeRearrangementModal"
        table_name="crm_list"
        is_dynamic="true"
      ></RearrangeManagement>
    </vs-popup>

    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      color="primary"
      class="add-new-data-sidebar items-no-padding no-scroll-sidebar"
      spacer
      v-model="get_leads_sidebar_view"
    >
      <!-- {{get_leads_sidebar_view}} -->
      <view-lead-sidebar
        v-if="get_leads_sidebar_data"
        :isSidebarActive="get_leads_sidebar_view"
        :get_leads_sidebar_data="get_leads_sidebar_data"
        @closeSidebar="handleViewSidebar"
      ></view-lead-sidebar>
    </vs-sidebar>

    <!-- Preview SideBar -->

    <!-- Create Lead Sidebar -->
    <!-- {{addSideBar}} -->
    <create-lead
      v-show="addSideBar"
      :staticFields="staticFields"
      :staticChildFields="staticChildFields"
      :countryList="countryList"
      :isSidebarActive="addSideBar"
      :clientPersonaList="clientPersonaList"
      :custom_fields_required="custom_fields_required"
      :dynamicFormObject="dynamicFormObject"
      @closeSidebar="handlcreateSidebar"
    ></create-lead>

    <!-- Create Lead Sidebar -->

    <!-- Filter Sidebar Component -->
    <filter-sidebar
      :isSidebarActive="filterSidebarBoolean"
      :fieldtabledata="fieldtabledata"
      :filterconditiondata="filterconditiondata"
      platformmodulename="CRM"
      @closedsidebarevent="filterSidebarEvent"
      name="crm_list"
    ></filter-sidebar>
    <!-- Filter Sidebar Component -->

    <vs-card class="cstm_vx_card mb-4">
      <div
        v-if="isRowSelected"
        style="font-size: 13.8px; padding: 7px; float: right"
      >
        <vs-button
          v-if="checkEditPermission()"
          class="custom-btn1"
          type="border"
          style="border-radius: 5px 0px 0px 5px"
          :disabled="!isRowSelected"
          @click="handleExport"
          >Export</vs-button
        >
        <vs-button
          class="custom-btn1"
          type="border"
          :disabled="!isRowSelected"
          @click="bulkMailAdd()"
          >Bulk Email</vs-button
        >
        <!-- <vs-button class="custom-btn1" type="border" :disabled="!isRowSelected"
          >Assign</vs-button
        > -->
        <vs-button
          class="custom-btn1"
          type="border"
          :disabled="!isRowSelected"
          @click="bulkupdateModal = !bulkupdateModal"
          >Update Field</vs-button
        >
        <vs-button
          v-if="checkDeletePermission()"
          class="custom-btn1"
          type="border"
          @click="openConfirmationModal"
          :disabled="!isRowSelected"
          >Delete</vs-button
        >
        <!-- <vs-dropdown
          vs-custom-content
          vs-trigger-click
          class="cursor-pointer"
          :disabled="!isRowSelected"
        >
          <vs-button
            class="custom-btn1 btnx"
            type="border"
            :disabled="!isRowSelected"
          >
            More
            <i
              class="material-icons"
              style="font-size: 12px; vertical-align: middle; font-weight: 600"
            >
              keyboard_arrow_down
            </i>
          </vs-button>
          <vs-dropdown-menu>
            <vs-dropdown-item> option 1 </vs-dropdown-item>
            <vs-dropdown-item> option 2 </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown> -->
        <!-- <vs-button
          class="custom-btn1"
          type="border"
          style="border-radius: 0px 5px 5px 0px"
          :disabled="!isRowSelected"
        >
          <i
            class="material-icons"
            style="font-size: 12px; vertical-align: middle; font-weight: 600"
          >
            sync
          </i>
        </vs-button> -->
      </div>

      <vs-popup
        classContent="popup-example"
        title="Please Confirm"
        :active.sync="showPopUpBool"
      >
        <h4>Are you sure to delete?</h4>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click="handleBulkDelete">Confirm</vs-button>
          <vs-button type="border" color="danger" @click="showPopUpBool = false"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>

      <vs-row class="mt-2">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="8"
          vs-sm="12"
          vs-xs="12"
        >
          <div class="md:w-1/2 w-full p-1">
            <vs-input
              placeholder="Search"
              class="w-full"
              v-model="search"
              @keyup="searchFun"
              style="width: 100%"
            />
          </div>

          <!-- {{select_filter_id}} -->

          <div class="p-1">
            <vs-tooltip
              color="primary"
              :text="kanban ? 'List' : 'Kanban'"
              position="top"
            >
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="kanban = !kanban"
              >
                <!-- <span v-if="!kanban">Kanban View</span> -->
                <svg
                  v-if="!kanban"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M41 5H7C5.89543 5 5 5.89543 5 7V41C5 42.1046 5.89543 43 7 43H41C42.1046 43 43 42.1046 43 41V7C43 5.89543 42.1046 5 41 5ZM7 3C4.79086 3 3 4.79086 3 7V41C3 43.2091 4.79086 45 7 45H41C43.2091 45 45 43.2091 45 41V7C45 4.79086 43.2091 3 41 3H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16 44L16 4L18 4L18 44L16 44Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M30 44L30 4L32 4L32 44L30 44Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7 8C7 7.44772 7.44772 7 8 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H8C7.44772 9 7 8.55228 7 8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20 8C20 7.44772 20.4477 7 21 7H26C26.5523 7 27 7.44772 27 8C27 8.55228 26.5523 9 26 9H21C20.4477 9 20 8.55228 20 8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M34 8C34 7.44772 34.4477 7 35 7H40C40.5523 7 41 7.44772 41 8C41 8.55228 40.5523 9 40 9H35C34.4477 9 34 8.55228 34 8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 13V16H12V13H9ZM8 11C7.44772 11 7 11.4477 7 12V17C7 17.5523 7.44772 18 8 18H13C13.5523 18 14 17.5523 14 17V12C14 11.4477 13.5523 11 13 11H8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22 13V16H25V13H22ZM21 11C20.4477 11 20 11.4477 20 12V17C20 17.5523 20.4477 18 21 18H26C26.5523 18 27 17.5523 27 17V12C27 11.4477 26.5523 11 26 11H21Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M36 13V16H39V13H36ZM35 11C34.4477 11 34 11.4477 34 12V17C34 17.5523 34.4477 18 35 18H40C40.5523 18 41 17.5523 41 17V12C41 11.4477 40.5523 11 40 11H35Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9 24V27H12V24H9ZM8 22C7.44772 22 7 22.4477 7 23V28C7 28.5523 7.44772 29 8 29H13C13.5523 29 14 28.5523 14 28V23C14 22.4477 13.5523 22 13 22H8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22 24V27H25V24H22ZM21 22C20.4477 22 20 22.4477 20 23V28C20 28.5523 20.4477 29 21 29H26C26.5523 29 27 28.5523 27 28V23C27 22.4477 26.5523 22 26 22H21Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M22 35V38H25V35H22ZM21 33C20.4477 33 20 33.4477 20 34V39C20 39.5523 20.4477 40 21 40H26C26.5523 40 27 39.5523 27 39V34C27 33.4477 26.5523 33 26 33H21Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M36 24V27H39V24H36ZM35 22C34.4477 22 34 22.4477 34 23V28C34 28.5523 34.4477 29 35 29H40C40.5523 29 41 28.5523 41 28V23C41 22.4477 40.5523 22 40 22H35Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
                <!-- <span v-else>List View</span> -->
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6 11.5C6 10.1193 7.11929 9 8.5 9H10.5C11.8807 9 13 10.1193 13 11.5C13 12.8807 11.8807 14 10.5 14H8.5C7.11929 14 6 12.8807 6 11.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6 23.5C6 22.1193 7.11929 21 8.5 21H10.5C11.8807 21 13 22.1193 13 23.5C13 24.8807 11.8807 26 10.5 26H8.5C7.11929 26 6 24.8807 6 23.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6 35.5C6 34.1193 7.11929 33 8.5 33H10.5C11.8807 33 13 34.1193 13 35.5C13 36.8807 11.8807 38 10.5 38H8.5C7.11929 38 6 36.8807 6 35.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 11.5C18 10.1193 19.1193 9 20.5 9L40.5 9C41.8807 9 43 10.1193 43 11.5C43 12.8807 41.8807 14 40.5 14L20.5 14C19.1193 14 18 12.8807 18 11.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 23.5C18 22.1193 19.1193 21 20.5 21L40.5 21C41.8807 21 43 22.1193 43 23.5C43 24.8807 41.8807 26 40.5 26L20.5 26C19.1193 26 18 24.8807 18 23.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18 35.5C18 34.1193 19.1193 33 20.5 33L40.5 33C41.8807 33 43 34.1193 43 35.5C43 36.8807 41.8807 38 40.5 38L20.5 38C19.1193 38 18 36.8807 18 35.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
            <!-- <vs-button primary style="font-weight: 700;"
            :to="{name:'leadDetails',
                  params:{'leadId':76}}"
            class="mr-3">view details</vs-button> -->
          </div>

          <!-- <div class="p-1" v-if="checkEditPermission()">
            <vs-tooltip color="primary" text="Filter" position="top">
              <vs-button
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-filter"
                style="margin-right: 1%"
                @click="handlefilterSidebar"
              />
            </vs-tooltip>
          </div> -->

          <div class="p-1">
            <vs-tooltip color="primary" text="Filter View" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="overallSearch"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <rect width="18" height="18" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11 14C12.6569 14 14 12.6569 14 11C14 9.34315 12.6569 8 11 8C9.34315 8 8 9.34315 8 11C8 12.6569 9.34315 14 11 14ZM11 15C13.2091 15 15 13.2091 15 11C15 8.79086 13.2091 7 11 7C8.79086 7 7 8.79086 7 11C7 13.2091 8.79086 15 11 15Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.1465 16.3536L13.1465 14.3536L13.8536 13.6465L15.8536 15.6465L15.1465 16.3536Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H15C16.3807 0.5 17.5 1.61929 17.5 3V14.5H16.5V3C16.5 2.17157 15.8284 1.5 15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V15C1.5 15.8284 2.17157 16.5 3 16.5H13.5V17.5H3C1.61929 17.5 0.5 16.3807 0.5 15V3Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.5 5.5H1.5V4.5H16.5V5.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 8.5H1.5V7.5H7.5V8.5ZM16.5 8.5H15V7.5H16.5V8.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.5 11.5H1.5V10.5H6.5V11.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.5 14.5H1.5V13.5H7.5V14.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.5 16.5V5H5.5V16.5H4.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>

          <div class="p-1" v-if="checkEditPermission()">
            <vs-tooltip color="primary" text="Rearrange Column" position="top">
              <vs-button
                @click="columnRearrangement"
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                icon="published_with_changes"
              >
              </vs-button>
            </vs-tooltip>
          </div>
          <div class="p-1" v-if="checkEditPermission()">
            <vs-tooltip color="primary" text="Import CSV/ XLS" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="excelModal()"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H22C18.6863 43 16 40.3137 16 37V24.5H18V37C18 39.2091 19.7909 41 22 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 28V32C10 34.2091 11.7909 36 14 36H24V38H14C10.6863 38 8 35.3137 8 32V28H10Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.36396 28.8284L4.41421 33.7782L3 32.364L9.36396 26L15.7279 32.364L14.3137 33.7782L9.36396 28.8284Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
          <div class="p-1" v-if="checkEditPermission()">
            <vs-tooltip color="primary" text="Export Template" position="top">
              <vs-button
                color="primary"
                type="border"
                class="includeIcon includeIconOnly"
                @click="exportApi"
              >
                <svg
                  style="width: 24px"
                  xmlns="http://www.w3.org/2000/svg"
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                >
                  <rect width="48" height="48" fill="white" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M19 7H7C5.89543 7 5 7.89543 5 9V21C5 22.1046 5.89543 23 7 23H19C20.1046 23 21 22.1046 21 21V9C21 7.89543 20.1046 7 19 7ZM7 5C4.79086 5 3 6.79086 3 9V21C3 23.2091 4.79086 25 7 25H19C21.2091 25 23 23.2091 23 21V9C23 6.79086 21.2091 5 19 5H7Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    d="M15.294 19.8L12.928 16.398L10.604 19.8H8L11.626 14.816L8.182 10H10.758L13.012 13.178L15.224 10H17.674L14.258 14.732L17.912 19.8H15.294Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.75 15V13H39C42.3137 13 45 15.6863 45 19V37C45 40.3137 42.3137 43 39 43H18C14.6863 43 12 40.3137 12 37V24.5H14V37C14 39.2091 15.7909 41 18 41H39C41.2091 41 43 39.2091 43 37V19C43 16.7909 41.2091 15 39 15H21.75Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 26V30C8 32.2091 9.79086 34 12 34H22V36H12C8.68629 36 6 33.3137 6 30V26H8Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.8995 34.6569L16.9498 39.6066L18.364 41.0208L24.728 34.6569L18.364 28.2929L16.9498 29.7071L21.8995 34.6569Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 21.5H26V19.5H38.5V21.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 27.5H26V25.5H38.5V27.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M38.5 33.5H26V31.5H38.5V33.5Z"
                    fill="rgba(var(--vs-primary), 1)"
                  />
                </svg>
              </vs-button>
            </vs-tooltip>
          </div>
        </vs-col>

        <vs-col vs-lg="4" vs-sm="12" vs-xs="12">
          <vs-row vs-type="flex" vs-justify="flex-end" vs-align="center">
            <vs-button
              v-if="checkCreatePermission()"
              class="btnx"
              type="border"
              style="margin-right: 1%"
              @click="excelModal()"
            >
              Upload CSV
            </vs-button>
            <vs-button
              v-if="checkCreatePermission()"
              class="btnx"
              style="margin-right: 1%"
              @click="addRecord"
            >
              Add Record
            </vs-button>
            <!--
   @click="filterSidebar = true"
  -->
            <!-- <vs-button color="primary" type="border" class="mr-2"
              >Widget Panel</vs-button
            > -->
            <!-- <vs-button
              color="primary"
              type="border"
              icon-pack="feather"
              icon="icon-filter"
              style="margin-right: 1%"
              @click="filterSidebarBoolean = !filterSidebarBoolean"
            /> -->
            <!-- <div class="dropdown-button-container">
              <vs-dropdown
                style="float: right; cursor: pointer"
                vs-custom-content
                vs-trigger-click
              >
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-settings"
                />
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    class=""
                    :to="{
                      name: 'field-re-arrange',
                      params: { module_name: 'leads' },
                    }"
                    >Customize Columns</vs-dropdown-item
                  >
                  <vs-dropdown-item
                    class=""
                    :to="{
                      name: 'custom-value-list-view',
                      params: { modelname: 'Leads' },
                    }"
                  >
                    Create Custom Fields
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div> -->
          </vs-row>
        </vs-col>
      </vs-row>
      <!-- table -->
    </vs-card>
    <div v-if="bulkupdateModal == true" class="update_modal_holder">
      <UpdateModal
        :active_status_list="active_status_list"
        :countryList="countryList"
        :custom_fields_required="custom_fields"
        :displayListofdata="displayListofdata"
        @bulkupdatelist="bulkupdatelist"
      ></UpdateModal>
    </div>

    <div v-if="overallSearchHolder">
      <vs-card class="cstm_vx_card mb-4">
        <div slot="header" class="flex flex-wrap justify-between items-center">
          <h4>Filter View</h4>
          <vs-button @click="handlefilterSidebar">Add Custom Filter</vs-button>
        </div>
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-align="center"
            vs-lg="12"
            vs-sm="12"
            vs-xs="12"
            class="sm:block block lg:flex"
          >
            <div class="lg:w-1/3 w-full p-1">
              <v-select
                placeholder="Select View"
                v-if="user_main_filter"
                class="w-full"
                label="filter_name"
                :options="user_main_filter"
                :reduce="(item) => item.id"
                :clearable="false"
                v-model="select_filter_id"
                @input="getFilterByLead()"
              >
              </v-select>
            </div>
            <div class="lg:w-1/3 w-full p-1">
              <v-select
                placeholder="Lead Type"
                class="w-full"
                :options="leadType"
                v-model="searchByLeadType"
                label="name"
                :reduce="(option) => option.value"
              >
              </v-select>
            </div>
            <div class="lg:w-2/3 w-full p-1">
              <v-select
                placeholder="Select tag to search"
                v-model="tagSelected"
                class="w-full"
                multiple
                label="name"
                taggable
                :create-option="
                  (option) => ({ id: option, label: option, name: option })
                "
                :options="tagModuleWise"
                :clearable="false"
                data-vv-name="tag_list"
                name="tag_list"
              >
              </v-select>
            </div>
            <div class="flex p-1">
              <vs-button
                class="mx-2 includeIcon includeIconOnly"
                @click="searchByfilter"
                >Go</vs-button
              >
              <vs-tooltip color="primary" text="Reset Filters" position="top">
                <vs-button
                  type="border"
                  icon-pack="feather"
                  @click="resetSearch"
                  icon="icon-refresh-cw"
                ></vs-button>
              </vs-tooltip>
            </div>
          </vs-col>
        </vs-row>
      </vs-card>
    </div>

    <div v-if="!kanban">
      <!-- <pre>{{columnDefs}}</pre> -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table crm-record-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :style="{ minHeight: limitedTableList.length * 48 + 75 + 'px' }"
        :rowData="limitedTableList"
        rowSelection="multiple"
        suppressRowClickSelection="true"
        colResizeDefault="true"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        @cell-value-changed="onCellValueChanged"
        @row-selected="CellvalueSelectDeselect"
        @cell-clicked="cellSingleClicked"
        @columnMoved="handleRearrangement"
        @columnVisible="handleColumnHideShow"
        :enableRtl="$vs.rtl"
        @sortChanged="sortFun"
      >
      </ag-grid-vue>
      <!--  @columnResized="resizeChanges($event)" -->
      <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
        <vs-col vs-w="4" vs-type="flex" vs-justify="start" vs-align="center">
          <!-- page limit select view -->
          <ItemsPerTableDropdown
            tableName="crm_list"
            @change="(pageLimit) => (pageLimitSet = pageLimit)"
          />
        </vs-col>
      </vs-row>
    </div>
    <div v-if="kanban">
      <kanban
        @kanbanData="kanbanData"
        @minTwoRowSelected="minTwoRowSelected"
        @getSelectedKanbanRows="getSelectedKanbanRows"
        :leadlist="limitedTableList"
        :active_status_list="active_status_list"
      ></kanban>
    </div>
    <pagination :meta="meta" @page-change="handlePageChange" class="ml-auto" />
    <vs-popup class="popup" title="Excel Upload" :active.sync="excelPopUp">
      <excel-modal
        v-if="excelPopUp"
        :custom_fields_required="custom_fields_required"
        :module_id="platform_module_id"
        model="lead"
        @uploadSuccess="uploadSuccess"
      ></excel-modal>
    </vs-popup>
  </div>
</template>
<script>
import axios from 'axios'
import { exportApiDownload } from '@/api/excelApi'
import DynamicBoolean from './DynamicBoolean.vue'
import DynamicSelect from './DynamicSelect.vue'
import DynamicDate from './DynamicDate'
import ExcelModal from '@/components/excel/ExcelModal.vue'
import BulkEmail from '../email/composeEmail.vue'
import { fetchCustomStaticFields } from '@/api/customfield'
import { GetCountryList } from '@/api/common'
import { fetchField } from '@/api/columnrearrange.js'
import UpdateModal from './components/updateModal'
import router from '@/router'
import Prism from 'vue-prism-component'
import TagShow from './TagShow'
import { Tag } from '@/mixins/tag/tag'
import {
  fetchleadBySearch,
  Lead_list,
  Delete_Leads,
  active_lead_status,
  persona_list,
  bulkUpdate,
  bulkEmailApi
} from '@/api/leads'
// import { fetchcustomfields} from '@/api/customfield'
// import { get_fields_filters, get_main_filter} from '@/api/filter'

import LeadSummary from '../analytics/summeryLIst'
import ViewLeadSidebar from './components/ViewLeadSidebar.vue'
import CreateLead from './components/CreateLead.vue'

import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import VxTimeline from '@/components/timeline/VxTimeline.vue'
import vSelect from 'vue-select'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from './CellRendererActions'
import ToggleActions from './ToggleActions'
import EditActions from './EditActions'
import DeleteActions from './DeleteActions'
import PreviewActions from './PreviewActions'
import AddCall from './AddCall'
import StatusCell from './statuscell'
import ImageCell from './ImageCell'
import PhoneImageCell from './PhoneImageCell'
import { mapGetters, mapActions } from 'vuex'
import Pagination from '@/components/common/pagination'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
//important common sidebar//
import FilterSidebar from '@/components/common/filter-sidebar'

import DynamicComponent from '@/components/common/DynamicComponent'
import { DynamicField } from '@/mixins/dynamic-field'
import { DynamicFilter } from '@/mixins/dynamic-filter'

import CountryCell from './CountryCell'
import CreatedAtCell from './CreatedAtCell'
import kanban from './kanban.vue'

//mixin middleware
import { PermissionMiddleware } from '../../../mixins/middleware/PermissionMiddleware'

import { LeadMixin } from './mixins/LeadMixin'

//mixin middleware

import { arrangeColumn } from '@/api/columnrearrange'

import RearrangeManagement from '@/views/pages/customFieldRearrage/RearrangeManagement'
//important common sidebar//
export default {
  components: {
    UpdateModal,
    Prism,
    StatisticsCardLine,
    VxTimeline,
    vSelect,
    AgGridVue,
    CellRendererActions,
    ToggleActions,
    EditActions,
    DeleteActions,
    PreviewActions,
    AddCall,
    StatusCell,
    Pagination,
    flatPickr,
    FilterSidebar,
    kanban,
    DynamicComponent,
    LeadSummary,
    ViewLeadSidebar,
    CreateLead,
    TagShow,
    CountryCell,
    BulkEmail,
    RearrangeManagement,
    ExcelModal,
    CreatedAtCell,
    DynamicDate,
    DynamicBoolean,
    DynamicSelect,
    ImageCell,
    PhoneImageCell
  },
  mixins: [DynamicField, DynamicFilter, PermissionMiddleware, LeadMixin, Tag],
  data () {
    return {
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      displayList: null,
      staticFields: [],
      staticChildFields: [],
      columnRearrangementModal: false,
      searchByLeadType: '',
      leadType: [
        {
          name: 'Individual',
          value: '0'
        },
        {
          name: 'Parent',
          value: '1'
        }
      ],
      search: '',
      platform_module_id: 1,
      overallSearchHolder: false,
      selected_lead_is: [],
      mail_id: [],
      bulkEmailModal: false,
      countryList: [],
      displayListofdata: [],
      bulkupdateModal: false,
      selectedKanbanItem: [],
      clientPersonaList: [],
      kanban: false,
      showPopUpBool: false,
      // selected: ['foo','bar'],
      filterSidebarBoolean: false,
      // created_by Sujay Ghosh(06-07-2020)
      company: '',
      email: '',
      phone: '',
      lead_name: '',
      lead_address1: '',
      lead_country: '',
      lead_city: '',
      errorCount: 0,
      persona_id: '',
      api_response_message_show: false,
      api_response_message: '',
      // End
      table_switch: false,
      addSideBar: false,
      viewSideBar: false,
      filterSidebar: false,
      maximizeCard: true,

      firstData: [], //for filter
      select_filter_id: '',

      //for getting custom field
      selected: [],
      /// filter work
      customFilterName: '',
      dynamicFormObject: {},

      /// filter
      //select checkbox
      select_All: false,
      excelPopUp: false,
      //
      // pagination
      //
      // pagelimit
      pageLimitOPtion: [
        {
          name: 5,
          value: 5
        },
        {
          name: 10,
          value: 10
        },
        {
          name: 20,
          value: 20
        }
      ],
      pageLimitSet: 5,
      //
      tableList: [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      /* timelineData: [
        {
          color: 'primary',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls1',
          time: '25 Days Ago'
        },
        {
          color: 'warning',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls2',
          time: '15 Days Ago'
        },
        {
          color: 'success',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls3',
          time: '20 mins ago'
        },
        {
          color: 'primary',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls4',
          time: '25 Days Ago'
        },
        {
          color: 'warning',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls5',
          time: '15 Days Ago'
        },
        {
          color: 'success',
          icon: 'CalendarIcon',
          title: 'Calendar Linked Calls6',
          time: '20 mins ago'
        }
      ], */
      tableData: [],
      selected_data: null,
      //Ag Grid Table
      gridApi: null,
      gridOptions: {
        accentedSort: true
      },
      gridColumnApi: null,
      defaultColDef: {
        suppressMenu: false,
        editable: true,
        sortable: true,
        resizable: true
        // autoHeight: true
      },
      columnApi: null,
      rowData: null,
      context: null,
      components: {
        CellRendererActions,
        ToggleActions,
        EditActions,
        DeleteActions,
        PreviewActions,
        AddCall,
        StatusCell,
        ImageCell,
        PhoneImageCell,
        TagShow,
        CountryCell,
        CreatedAtCell,
        DynamicDate,
        DynamicBoolean,
        DynamicSelect
      },
      columnDefs: [],
      columnDefsBackup: [],
      staticDisplayField: [
        {
          field_label: 'First Name',
          field_name: 'lead_first_name'
        },
        {
          field_label: 'Last Name',
          field_name: 'lead_last_name'
        },
        {
          field_label: 'City',
          field_name: 'lead_city'
        }
      ],
      staticField: [
        {
          headerName: '',
          width: 45,
          field: 'isSelected',
          filter: false,
          resizable: false,
          checkboxSelection: (params) => {
            if (params.data.is_active === '1') {
              return true
            } else {
              return false
            }
          },
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true
        },
        {
          headerName: '#',
          field: 'row_index',
          sortable: false,
          filter: false,
          minWidth: 60,
          resizable: true,
          editable: false
        },
        {
          headerName: 'Last Name',
          field: 'lead_last_name',
          maxWidth: 150,
          filter: false,
          editable: false
        },
        {
          headerName: 'Company',
          field: 'company',
          minWidth: 150,
          filter: false,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.is_active === '1') {
              return true
            } else {
              return false
            }
          }
          // width: 150
        },
        {
          headerName: 'Email',
          field: 'email',
          minWidth: 150,
          filter: false,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.is_active === '1') {
              return true
            } else {
              return false
            }
          }
          // width: 150
        },
        // {
        //   headerName: "Phone",
        //   field: "phone",
        //   minWidth: 150,
        //   filter: false,
        //   cellRendererFramework: "PhoneImageCell",
        //   editable: (params) => {
        //     if (!this.checkEditPermission()) {
        //       return false;
        //     }
        //     if (params.data.is_active === "1") {
        //       return true;
        //     } else {
        //       return false;
        //     }
        //   },
        // },
        {
          headerName: 'Tags',
          field: 'tags',
          minWidth: 150,
          filter: false,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.is_active === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Assigned',
          field: 'assigned',
          filter: false,
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.is_active === '1') {
              return true
            } else {
              return false
            }
          }
        },
        /*    {
          headerName: 'Status',
          field: 'complete_status',
          editable: false,
          cellRendererFramework: 'StatusCell',
          filter: true,
          minWidth: 200
        }, */
        /*   {
          headerName: 'Source',
          field: 'source',
          filter: false,
          minWidth: 125,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.is_active === '1') {
              return true
            } else {
              return false
            }
          }
        }, */
        {
          headerName: 'Last Contact',
          field: 'last_contact',
          filter: 'agNumberColumnFilter',
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.is_active === '1') {
              return true
            } else {
              return false
            }
          }
        },
        {
          headerName: 'Created',
          field: 'created_at',
          filter: 'agNumberColumnFilter',
          minWidth: 150,
          editable: (params) => {
            if (!this.checkEditPermission()) {
              return false
            }
            if (params.data.is_active === '1') {
              return true
            } else {
              return false
            }
          }
        }
        // {
        //   headerName: 'Action',
        //   field: 'actionData',
        //   editable:false,
        //   filter: false,
        //   cellRendererFramework: 'CellRendererActions'
        // }
      ],
      /// bulk buttons
      isRowSelected: false,
      active_status_list: [],
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1,
        limit: 10,
        customer_id: this.$store.getters.customerId
      }
    }
  },
  watch: {
    columnRearrangementModal () {
      if (!this.columnRearrangementModal) {
        this.fetchingDynamicFieldAndFilter()
        this.fetchDisplayFields('CRM', this.$store.getters.customerId)
        this.searchByfilter()
        // this.gridOptions.api.refreshCells()
      }
    },
    tagSelected () {
      this.filterTagList(this.platform_module_id)
    },
    kanban () {
      if (!this.kanban) {
        // this.gridOptions.api.refreshCells()
        const query = {
          page: 1,
          limit: this.pageLimitSet,
          customerId: this.$store.getters.customerId
        }

        this.fetch_list(query)
      }
    },
    pageLimitSet () {
      this.handlePageChange(1)
    },
    get_leads_deleted_id () {
      if (this.get_leads_deleted_id) {
        const table = this.tableData
        const dlt_id = table.findIndex(
          (item) => item.leads_id === this.get_leads_deleted_id
        )
        table.splice(dlt_id, 1)
        table.map((row, index) => {
          row.row_index =
            this.meta.total -
            this.meta.limit * (this.meta.current_page - 1) -
            index
        })
        this.tableData = table

        if (this.tableData.length === 0 && !this.meta.next_page_url) {
          this.handlePageChange(this.meta.current_page - 1)
        } else {
          this.handlePageChange(this.meta.current_page)
        }
      }
    },
    get_leads_toggle_data: {
      deep: true,
      handler () {
        const table = this.tableData
        table.map((element) => {
          if (
            element.leads_id === this.get_leads_toggle_data.row_details.leads_id
          ) {
            element.is_active =
              this.get_leads_toggle_data.row_details.is_active
            element.actionData.toggle = this.get_leads_toggle_data.toggle
          }
        })
        this.tableData = table
      }
    }
  },

  async created () {
    await this.fetchingDynamicFieldAndFilter()
    await this.fetchCountry()
    await this.fetch_field_list()
    await this.fetchDisplayFields('CRM', this.$store.getters.customerId)
    await this.gridOptions.api.sizeColumnsToFit()
    await this.checkingQuery()
    await this.fetch_leads_active_status()
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('CRM')
    }
    // await Promise.all([
    //   this.checkingQuery(),
    //   this.fetchCountry(),
    //   this.fetch_leads_active_status(),
    //   this.fetchDisplayFields('CRM', this.$store.getters.customerId),
    //   this.fetch_field_list()
    // ])


    this.gridApi = this.gridOptions.api
    const queryParams = this.$route.query || {}
    this.query_page.page = queryParams.page || 1
    this.query_page.limit = queryParams.limit || 10

    //fetching dynamic fields and field and filer list

    //fetching dynamic fields angridOptionsd field and filer list

    await this.fetchPersonaList()
    //filterquery//
    // this.fetch_table_filter_data('Leads')

    //user_main_filter
    await this.fetchMainFilter('CRM', 'crm_list')

    //user_main_filter
    // this.fetchStatus()
    this.query_page.customer_id = this.$store.getters.customerId
  },
  mounted () {
    this.fetchingDynamicFieldAndFilter()
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        '.ag-header-container'
      )
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
    /*
    ) */
    this.$nextTick(() => { })

    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi

    // this.gridApi = this.gridOptions.api
  },
  provide () {
    return {
      $validator: this.$validator
    }
  },
  errorCaptured (err, vm, info) { },
  activated () { },
  deactivated () { },
  methods: {
    closeRearrangementModal (value) {
      if (value) {
        this.columnRearrangementModal = false
      }
    },
    openConfirmationModal () {
      this.showPopUpBool = true
    },
    minTwoRowSelected (noOfSeletedItems) {
      this.isRowSelected = noOfSeletedItems > 1
    },
    resizeChanges: _.debounce(async function (e) {
      //Taking all existing columns from ag-grid table showing now to get order and field name information
      const all_columns = this.gridColumnApi
        .getAllDisplayedColumns()
        .map((column) => column.getColId())

      const orders_info = []
      all_columns.forEach((value, key) => {
        orders_info.push({
          field_name: value,
          order: key
        })
      })
      const fields_display_order = []
      this.displayList.forEach((element, key) => {
        fields_display_order.push({
          fields_display_order_id: element.id,
          displayed: element.displayed,
          field_type: element.field_type,
          field_name: element.field_name,
          field_id: element.field_id,
          order: key,
          field_label: element.field_label,
          is_child: element.is_child,
          is_static: element.is_static,
          input_type: element.input_type,
          column_width:
            element.field_name == e.column.colId
              ? e.column.actualWidth
              : element.column_width
        })
        // }
      })

      //Final payload object for re-arrangement API
      const payload = {
        fields_display_order,
        customer_id: this.$store.getters.customerId,
        from_list: '0',
        type: 'CRM'
      }

      const allGridColumns = this.gridOptions.columnApi.getAllGridColumns()
      this.columnDefsBackup = allGridColumns.map((ele) => {
        return ele.colDef
      })

      //Finally calling API to save column by providing the payload generated from the above codes and logic
      this.rearrangeColumn(payload)
    }, 2000),
    async sortFun () {
      try {
        const sortState = this.gridApi.getSortModel()
        this.sorting_obj.field_type = sortState.length != 0 ? this.gridOptions.columnApi.getColumn(
          sortState[0].colId
        ).colDef.field_type : ''
        this.sorting_obj.attribute = sortState.length != 0 ? sortState[0].colId : ''
        this.sorting_obj.direction = sortState.length != 0 ? sortState[0].sort : ''

        const statusList = await this.fetch_leads_active_status()
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId
        }
        this.$vs.loading({
          text: 'Loading...'
        })
        fetchleadBySearch(payload, this.meta, this.sorting_obj).then(
          (data) => {
            const table = data.data.data.results
            this.meta = data.data.data.meta
            table.map((row) => {
              const actionData = {
                toggle: row.is_active === '1',
                view: false
              }
              const status_list = statusList
              Object.assign(row, { actionData })
              Object.assign(row, { status_list })
            })
            this.tableData = table
            this.gridOptions.api.refreshCells()
            this.$vs.loading.close()
          }
        )

        this.fetchTag(this.platform_module_id)
      } catch (e) {
        //
      }
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        const statusList = await vm.fetch_leads_active_status()
        const payload = {
          search: vm.search,
          customer_id: vm.$store.getters.customerId
        }
        vm.meta.current_page = 1

        const { data } = await fetchleadBySearch(
          payload,
          vm.meta,
          vm.sorting_obj
        )
        const table = data.data.results
        vm.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.is_active === '1',
            view: false
          }
          row.row_index =
            vm.meta.total - vm.meta.limit * (vm.meta.current_page - 1) - index
          const status_list = statusList
          Object.assign(row, { actionData })
          Object.assign(row, { status_list })
        })
        vm.tableData = table
        vm.fetchTag(vm.platform_module_id)
      } catch (e) {
        console.log(e)
      }
    }, 1000),

    checkIfRequiredField (params) {
      const { headerName } = params
      const requiredFields = ['First Name', 'Last Name', 'Email']
      if (requiredFields.includes(headerName)) {
        return true
      } else {
        return false
      }
    },
    async exportApi () {
      const data = await exportApiDownload(
        this.$store.getters.customerId,
        'lead'
      )
      this.downloadItem(data.data.data.url, data.data.data.name)
    },
    downloadItem (url, label) {
      axios
        .get(url, { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'mime' })
          // const blob = new Blob([response.data], { type: 'application/pdf' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          //link.download = `${label}.${url.split('.')[url.split('.').length - 1]}`
          link.download = `${label}`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    kanbanData (data) {
      const table = this.tableData
      table.map((element) => {
        if (element.leads_id === data.leads_id) {
          element.is_active = data.is_active
          element.actionData.toggle = data.toggle
        }
      })
      this.tableData = table
      this.gridOptions.api.refreshCells()
    },
    closeModal (value) {
      if (value) {
        this.columnRearrangementModal = false
      }
    },
    excelModal () {
      this.excelPopUp = true
    },
    fetchingDynamicFieldAndFilter () {
      const customField = this.fetch_customfields_list('CRM')
      customField.then((responseData) => {
        if (responseData) {
          this.fetchFieldAndFilterList('CRM', 'crm_list') //this is fetching dynamic field and static field for filter modules
        }
      })
    },
    uploadSuccess (success) {
      if (success) {
        this.excelPopUp = false
        this.searchByfilter()
      }
    },
    resetSearch () {
      this.select_filter_id = null
      this.tagSelected = []
      this.searchByLeadType = ''
      this.search = ''
      this.handlePageChange(1)
    },
    async fetch_field_list () {
      try {
        const customerId = this.$store.getters.customerId
        const { data } = await fetchCustomStaticFields(1, customerId)

        this.staticFields = data.data.module_fields
        this.staticChildFields = data.data.module_child_fields
      } catch (e) {
        //
      }
    },
    searchByfilter () {
      const tags = this.tagSelected.map((element) => {
        return element.id
      })

      const payload = {
        user_type: this.searchByLeadType,
        tag_ids: tags,
        page: 1,
        limit: this.pageLimitSet,
        customerId: this.$store.getters.customerId
      }

      this.fetch_list(payload)
    },
    //Checking Query For Pagination in
    async checkingQuery () {
      if (
        this.$route.query &&
        'page' in this.$route.query &&
        !isNaN(this.$route.query.page)
      ) {
        this.meta.current_page = parseInt(this.$route.query.page)
      } else {
        const queryPayload = Object.assign({}, this.$route.query)
        queryPayload.page = 1
        this.$router
          .replace({ path: '/pages/leads', query: queryPayload })
          .catch(() => { })
      }
    },
    ...mapActions([
      'SET_DELETE_ID',
      'SET_VIEW_LEADS_SIDEBAR',
      'SET_VIEW_LEADS_SIDEBAR_DATA',
      'SET_LEADS_ACTIVE_STATUS'
    ]),
    myCallback () { },
    /*  onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    }, */
    addRecord () {
      this.addSideBar = true
      document.body.classList.add('overflow-hidden')
    },
    columnRearrangement () {
      this.columnRearrangementModal = true
    },
    bulkMailAdd () {
      const BulkSelected = this.getSelectedRows()
      const mail_ids = BulkSelected.filter((ele) => {
        return ele.is_active === '1'
      }).map((ele) => {
        return ele.Email
      })

      this.selected_lead_is = BulkSelected.map((ele) => {
        return ele.leads_id
      })
      this.mail_id = mail_ids
      this.bulkEmailModal = true
    },
    async mail_body (mail_details) {
      const payload = {
        leads_ids: this.selected_lead_is,
        header: mail_details[1],
        body: mail_details[2],
        customer_id: this.$store.getters.customerId
      }
      const { data } = await bulkEmailApi(payload)
      this.bulkEmailModal = false
      this.$vs.notify({
        title: 'Success',
        text: 'Email sent Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    async fetchCountry () {
      try {
        const { data } = await GetCountryList()
        this.countryList = data.data.countries_list
      } catch (e) {
        console.warn(e)
      }
    },
    async fetchDisplayFields (moduleName, customerId) {
      //
      try {
        const payload = {
          customer_id: customerId,
          fetch_status: 'display',
          type: 'CRM',
          table_name: 'crm_list'
        }
        const { data } = await fetchField(payload)
        const displayList = data.data.results
        this.displayList = displayList
        let displayColomns = []
        if (displayList.length === 0) {
          displayColomns = this.staticField
          this.displayListofdata = this.staticDisplayField
        } else {
          this.displayListofdata = displayList
          for (const item of displayList) {
            if (item.field_type === 'dynamic') {
              if (item.input_type === 'datetime') {
                const _tempObj = {
                  headerName: item.field_label,
                  field: item.field_name,
                  filter: false,
                  minWidth: item.column_width,
                  cellRendererFramework: 'DynamicDate',
                  CellRendererParams: item.field_name,
                  editable: false,
                  sortable: false,
                  field_type: item.field_type,
                  table_name: item.table_name
                }
                displayColomns.push(_tempObj)
              } else if (item.input_type === 'boolean') {
                const _tempObj = {
                  headerName: item.field_label,
                  field: item.field_name,
                  filter: false,
                  sortable: false,
                  minWidth: item.column_width,
                  cellRendererFramework: 'DynamicBoolean',
                  CellRendererParams: item.field_name,
                  editable: true,
                  table_name: item.table_name,
                  field_type: item.field_type
                }
                displayColomns.push(_tempObj)
              } else if (item.input_type === 'select') {
                const _tempObj = {
                  headerName: item.field_label,
                  table_name: item.table_name,
                  field: item.field_name,
                  filter: false,
                  sortable: false,
                  minWidth: item.column_width,
                  cellRendererFramework: 'DynamicSelect',
                  CellRendererParams: {
                    item_name: item.field_name,
                    custom_fields: this.custom_fields.filter((ele) => {
                      if (ele.input_type === 'select') {
                        return ele
                      }
                    })
                  },
                  editable: true,
                  field_type: item.field_type
                }
                displayColomns.push(_tempObj)
              } else if (
                item.input_type !== 'datetime' &&
                item.input_type !== 'boolean' &&
                item.input_type !== 'select'
              ) {
                const _tempObj = {
                  input_type: item.input_type,
                  sortable: false,
                  headerName: item.field_label,
                  field: item.field_name,
                  filter: false,
                  table_name: item.table_name,
                  minWidth: item.column_width,
                  field_type: item.field_type,
                  editable: (params) => {
                    if (
                      item.input_type !== 'checkbox' &&
                      item.input_type !== 'multiselect' &&
                      item.input_type !== 'radio'
                    ) {
                      return true
                    } else {
                      return false
                    }
                  }
                }
                displayColomns.push(_tempObj)
              }
            } else if (item.field_label === 'First Name') {
              const _tempObj = {
                headerName: 'Full Name',
                field: 'lead_first_name',
                filter: false,
                minWidth: item.column_width,
                sortable: true,
                cellRendererFramework: 'ImageCell',
                table_name: item.table_name,
                field_type: item.field_type,
                editable: false
              }
              displayColomns.push(_tempObj)
            } else if (item.field_label === 'Phone') {
              const _tempObj = {
                headerName: item.field_label,
                field: item.field_name,
                filter: false,
                cellRendererFramework: 'PhoneImageCell',
                minWidth: item.column_width,
                sortable: true,
                table_name: item.table_name,
                field_type: item.field_type,
                editable: (params) => {
                  if (params.data.is_active === '1') {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (item.field_label === 'Country') {
              const _tempObj = {
                headerName: item.field_label,
                field: item.field_name,
                table_name: item.table_name,
                filter: false,
                minWidth: item.column_width,
                cellRendererFramework: 'CountryCell',
                filterParams: this.countryList,
                field_type: item.field_type,
                editable: (params) => {
                  if (params.data.is_active === '1') {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            } else if (item.field_label === 'Created at') {
              const _tempObj = {
                headerName: 'Date Created',
                field: item.field_name,
                table_name: item.table_name,
                filter: false,
                minWidth: item.column_width,
                cellRendererFramework: 'CreatedAtCell',
                field_type: item.field_type,
                editable: false
              }
              displayColomns.push(_tempObj)
            } else if (item.field_label === 'Status') {
              const _tempObj = {
                headerName: 'Status',
                field: 'lead_status_id',
                table_name: item.table_name,
                editable: true,
                cellRendererFramework: 'StatusCell',
                filter: false,
                minWidth: item.column_width,
                filterParams: this.active_status_list,
                field_type: item.field_type
              }
              displayColomns.push(_tempObj)
            } else {
              const _tempObj = {
                headerName: item.field_label,
                field: item.field_name,
                table_name: item.table_name,
                filter: false,
                minWidth: item.column_width,
                field_type: item.field_type,
                editable: (params) => {
                  if (params.data.is_active === '1' && item.field_name !== 'email') {
                    return true
                  } else {
                    return false
                  }
                }
              }
              displayColomns.push(_tempObj)
            }
          }
          const staticField1 = {
            headerName: '',
            minWidth: 45,
            maxWidth: 45,
            field: 'isSelected',
            filter: false,
            resizable: false,
            checkboxSelection: (params) => {
              return true
            },
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true
          }
          // displayColomns.shift()
          // const phoneimage = {
          //   headerName: 'Phone',
          //   field: 'phone',
          //   cellRendererFramework: 'PhoneImageCell',
          //   filter: false,
          //   minWidth: 150,
          //   filterParams: this.countryList,
          //   resizable: true,
          //   cellStyle: { color: 'blue' },
          //   editable: false,
          //   suppressMovable: false,
          //   field_type: 'jsx'
          // }
          // displayColomns.unshift(phoneimage)
          // const fullname = {
          //   headerName: 'Name',
          //   field: 'fullname',
          //   cellRendererFramework: 'ImageCell',
          //   filter: false,
          //   minWidth: 150,
          //   resizable: true,
          //   cellStyle: { color: 'blue' },
          //   editable: false,
          //   suppressMovable: false,
          //   field_type: 'jsx'
          // }
          // displayColomns.unshift(fullname)

          // const staticField2 = {
          //   headerName: '#',
          //   field: 'row_index',
          //   filter: false,
          //   sortable: false,
          //   minWidth: 100,
          //   maxWidth: 100,
          //   editable: false,
          //   valueGetter: (params) => {
          //     return (
          //       this.meta.limit * (this.meta.current_page - 1) +
          //       params.node.rowIndex +
          //       1
          //     )
          //   }
          //   //  valueGetter: 'node.rowIndex',
          // }
          // displayColomns.unshift(staticField2)
          displayColomns.unshift(staticField1)
        }

        const tags = {
          headerName: 'Tags',
          sortable: false,
          field: 'tags',
          editable: false,
          cellRendererFramework: 'TagShow',
          filter: false,
          minWidth: 200,
          field_type: 'system'
        }
        displayColomns.push(tags)
        const actionField = {
          headerName: 'Active Status',
          sortable: false,
          field: 'actionData',
          editable: false,
          filter: false,
          cellRendererFramework: 'ToggleActions',
          minWidth: 90,
          maxWidth: 90,
          CellRendererParams: { tableData: this.tableData }
          // cellRendererFramework: 'CellRendererActions'
        }
        displayColomns.push(actionField)

        if (this.checkEditPermission()) {
          const actionField1 = {
            headerName: 'Actions',
            field: 'actionData',
            sortable: false,
            editable: false,
            filter: false,
            // cellRendererFramework: "EditActions",
            minWidth: 100,
            maxWidth: 100,
            cellRendererFramework: 'CellRendererActions'
          }
          displayColomns.push(actionField1)
        }

        this.columnDefs = displayColomns
        this.columnDefsBackup = displayColomns
        // this.columnDefs.push({headerName: 'New Column'})

        this.gridOptions.api.setColumnDefs(displayColomns)
        this.gridOptions.api.refreshCells({ force: true })
      } catch (e) {
        console.warn(e)
      }
    },
    async bulkupdatelist (updated_details) {
      try {
        const BulkSelected = this.getSelectedRows()

        const updated_ids = []
        for (let i = 0; i < BulkSelected.length; i++) {
          if (BulkSelected[i].is_active === '1') {
            updated_ids.push(BulkSelected[i].leads_id)
          }
          // }
        }

        if (updated_ids.length === 0) {
          this.$vs.notify({
            title: 'Warning',
            text: 'Selected row\'s are not Actionable',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        } else {
          const payload = {
            leads_ids: updated_ids,
            customer_id: this.$store.getters.customerId,
            field_name: updated_details[0],
            value: updated_details[1]
          }
          bulkUpdate(payload).then((data) => {
            const newRowData = this.tableData.map((row) => {
              if (updated_ids.includes(row.leads_id)) {
                row[updated_details[0]] = data.data.data.value
              }
              return row
            })
            this.tableData = newRowData
            this.$vs.notify({
              title: 'Success',
              text: 'Updated successfully',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
          })
          this.bulkupdateModal = false
          this.isRowSelected = false
        }
      } catch (e) { }
    },
    getFilterByLead () {
      const query = {
        page: 1,
        limit: this.pageLimitSet,
        customerId: this.$store.getters.customerId
      }
      if (this.select_filter_id == null) {
        this.fetch_list(query)
      } else {
        const params = {
          filter_id: this.select_filter_id
        }
        query.filter_id = this.select_filter_id
        this.fetch_list(query, params)
      }
    },

    async fetch_leads_active_status () {
      try {
        const { data } = await active_lead_status(
          this.$store.getters.customerId
        )
        this.$vs.loading.close()
        this.active_status_list = data.data.leads_status_list
        this.SET_LEADS_ACTIVE_STATUS(data.data.leads_status_list)

        return data.data.leads_status_list
        // this.fetch_list(this.query_page)
      } catch (e) {
        //
      }
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      if (this.kanban) {
        return this.selectedKanbanItem
      }
      return selectedData
    },
    getSelectedKanbanRows (selectedItem) {
      this.selectedKanbanItem = selectedItem
    },
    paginationPageSize () {
      //
      return this.pageLimitSet
    },
    handleBulkDelete () {
      const BulkSelected = this.getSelectedRows()
      const deleting_ids = []
      for (let i = 0; i < BulkSelected.length; i++) {
        if (BulkSelected[i].is_active != '1') {
          deleting_ids.push(BulkSelected[i].leads_id)
        }
        // }
      }
      if (deleting_ids.length === 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Selected rows are non-actionable',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        const payload = {
          leads_id: deleting_ids,
          customer_id: this.$store.getters.customerId
        }

        Delete_Leads(payload)
          .then((data) => {
            const table = this.tableData
            for (const delete_id_itr of deleting_ids) {
              for (let i = 0; i < table.length; i++) {
                //
                if (delete_id_itr === table[i].leads_id) {
                  table.splice(i, 1)
                  // break
                }
              }
            }
            table.map((row, index) => {
              row.row_index =
                this.meta.total -
                this.meta.limit * (this.meta.current_page - 1) -
                index
            })
            this.tableData = table
            this.isRowSelected = false
            this.showPopUpBool = false

            if (this.tableData.length === 0 && !this.meta.next_page_url) {
              this.handlePageChange(this.meta.current_page - 1)
            } else {
              this.handlePageChange(this.meta.current_page)
            }

            this.$vs.notify({
              title: 'Success',
              text: 'Bulk Deletion Successfull',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
            //
          })
          .catch((e) => { })
      }
      //
      // bul
      // for( let )
    },
    handleExport () {
      let exportURL = `${process.env.VUE_APP_API_URL}leads_csv_download?`
      const BulkSelected = this.getSelectedRows()
      for (let i = 0; i < BulkSelected.length; i++) {
        //if (BulkSelected[i].is_active === '1') {
        if (typeof BulkSelected[i + 1] === 'undefined') {
          exportURL += `leads_id[]=${BulkSelected[i].leads_id}`
        } else {
          exportURL += `leads_id[]=${BulkSelected[i].leads_id}&`
        }
        //}
      }
      //window.open(exportURL, '_self')
      this.openInNewTab(exportURL)
    },
    openInNewTab (href) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        href
      }).click()
    },
    showDetails (data) {
      this.viewSideBar = true
      this.selected_data = data
    },
    async fetch_list (query, params = null) {
      const statusList = await this.fetch_leads_active_status()
      // const limit = 20
      const text = params
        ? 'Fetching Filter Lead List ...'
        : 'Fetching Lead List...'
      this.$vs.loading({
        text
      })

      try {
        if (this.select_filter_id) {
          query.filter_id = this.select_filter_id
        }
        const { data } = await Lead_list(query)
        //
        const table = data.data.results
        this.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.is_active === '1',
            view: false
          }
          row.row_index =
            this.meta.total -
            this.meta.limit * (this.meta.current_page - 1) -
            index
          const status_list = statusList
          Object.assign(row, { actionData })

          Object.assign(row, { status_list })
        })
        this.tableData = table

        this.fetchTag(this.platform_module_id)
      } catch (e) {
      } finally {
        this.$vs.loading.close()
      }
    },
    //
    get_table_id (id, table) {
      //id => number, table => array ... matching.
      for (let i = 0; i > table.length; i++) {
        if (table[i].leads_id === id) {
          return i
        }
      }
    },
    fetchPersonaList () {
      persona_list()
        .then((response) => {
          this.clientPersonaList = response.data.data.personaList
        })
        .catch((error) => {
          this.addSideBar = false
          this.$vs
            .notify({
              title: 'Warning',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
            .catch((error) => {
              this.addSideBar = false
              this.$vs.notify({
                title: 'Warning',
                text: error.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                time: 8000
              })
            })
        })
    },

    handleDelete (tableList) {
      if (tableList.isActionable) {
        const table = this.tableData
        const rowId = tableList.leads_id
        let deleted_index = null
        //
        for (let i = 0; i < table.length; i++) {
          if (rowId === table[i].leads_id) {
            deleted_index = i
            break
          }
        }
        table.splice(1, deleted_index)
        this.tableData = table
        this.$vs.notify({
          title: 'Lead deleted',
          text: 'Lead deleted successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Cant Delete Lead, Turn on Action Button',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      }
    },

    handleViewSidebar () {
      const viewleads = false
      this.SET_VIEW_LEADS_SIDEBAR(viewleads)
      this.SET_VIEW_LEADS_SIDEBAR_DATA(null)
    },
    handlcreateSidebar (addedObject) {
      if (addedObject === false) {
        this.addSideBar = false
        document.body.classList.remove('overflow-hidden')
        this.$validator.errors.clear('Add_Lead')
      } else {
        if (addedObject.saveType == 'SaveAndClose') {
          this.addSideBar = false
        }
        document.body.classList.remove('overflow-hidden')
        this.$validator.errors.clear('Add_Lead')
        this.addNewLead(addedObject)
      }
    },
    addNewLead (added) {
      this.SET_VIEW_LEADS_SIDEBAR_DATA(added)
      const actionData = {
        toggle: true,
        view: false
      }
      const status_list = this.active_status_list
      Object.assign(added, { status_list })
      Object.assign(added, { actionData })
      const addedarray = [added]
      this.tableData = [...addedarray, ...this.tableData]
      const table = this.tableData
      table.map((row, index) => {
        row.row_index =
          this.meta.total -
          this.meta.limit * (this.meta.current_page - 1) -
          index
      })
      this.tableData = table
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      if (selectedNodes) {
        const selectedRows = selectedNodes.map((node) => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },

    handlePageChange (page) {
      //      //
      const tags = this.tagSelected.map((element) => {
        return element.id
      })

      setTimeout(() => {
        const queryPayload = Object.assign({}, this.$route.query)
        queryPayload.user_type = this.searchByLeadType
        queryPayload.tag_ids = tags
        queryPayload.page = page
        queryPayload.limit = this.pageLimitSet
        queryPayload.search = this.search
        queryPayload.customerId = this.$store.getters.customerId

        const pageScroll = document.documentElement.scrollTop
        this.$router
          .replace({ path: '/pages/leads', query: queryPayload })
          .catch(() => { })
          .then(() => {
            document.documentElement.scrollTop = pageScroll
          })

        if (this.select_filter_id === null) {
          this.fetch_list(queryPayload)
        } else if (this.search !== '' || this.sorting_obj.attribute !== '') {
          this.searchFunPage()
        } else {
          const params = {
            filter_id: this.select_filter_id
          }
          this.fetch_list(queryPayload, params)
        }
      }, 0)
    },
    async searchFunPage () {
      try {
        const statusList = await this.fetch_leads_active_status()
        const payload = {
          search: this.search,
          customer_id: this.$store.getters.customerId
        }

        this.$vs.loading({
          text: 'Loading...'
        })

        const { data } = await fetchleadBySearch(
          payload,
          this.meta,
          this.sorting_obj
        )
        const table = data.data.results
        this.meta = data.data.meta
        table.map((row, index) => {
          const actionData = {
            toggle: row.is_active === '1',
            view: false
          }
          row.row_index =
            this.meta.total -
            this.meta.limit * (this.meta.current_page - 1) -
            index
          const status_list = statusList
          Object.assign(row, { actionData })
          Object.assign(row, { status_list })
        })
        this.tableData = table
        this.fetchTag(this.platform_module_id)
      } catch (e) {
      } finally {
        this.$vs.loading.close()
      }
    },
    cellSingleClicked (params) {
      //
      if (params.column.colId === 'lead_first_name') {
        router.push({
          name: 'leadDetails',
          params: { leadId: parseInt(params.data.leads_id) }
        })
      }
    },
    handleColumnHideShow (params) {
      const allowHide = this.checkIfRequiredField(params.column.colDef)
      if (allowHide) {
        this.columnDefs = []
        setTimeout(() => {
          this.gridOptions.api.setColumnDefs(this.columnDefsBackup)
          this.gridOptions.api.sizeColumnsToFit()
        }, 0)
      } else {
        this.handleRearrangement(params, true)
      }
    },
    handleRearrangement (param, fromHandleColumnHideShow) {

      //Taking all existing columns from ag-grid table showing now to get order and field name information
      const all_columns = this.gridColumnApi
        .getAllDisplayedColumns()
        .map((column) => column.getColId())

      // Generating above columns orders (Column Index) and field_name object.
      // Here all the Ag-grid column received are already in arranged or sorted order by ag-grid itself after the rearrangement we do
      const orders_info = []
      all_columns.forEach((value, key) => {
        orders_info.push({
          field_name: value,
          order: key
        })
      })

      //Just providing a 100 milisecond for loop above to be completed before further process, it's quite important here
      setTimeout(() => {
        let column_rearranged = null
        //Taking currect rearranged column information by ag-grid 'columnMoved' event to give it a new order
        column_rearranged = this.displayList.filter((x) => {
          return x.field_name === param.column.colId
        })

        //Check if event fired is ag-grid columnVisible (fromHandleColumnHideShow)
        if (fromHandleColumnHideShow) {
          column_rearranged = this.displayList.filter((x) => {
            return x.field_name === param.column.colId
          })
        }

        // const old_order = column_rearranged[0].order
        // const new_order = param.toIndex - 1

        //Checking if currect rearranged column is inside the array of column to show given by backend then proceed else just skip
        if (column_rearranged.length) {

          column_rearranged[0].order =
            orders_info.filter((x) => {
              return x.field_name === param.column.colId
            }).order - 1

          //Just delete old information since we need new order infor, we can also just change order property here,
          //I just removed and added again with new order information, both will work here
          this.displayList.splice(
            this.displayList.findIndex(
              (x) => x.field_name === param.column.colId
            ),
            1
          )

          //Adding again the removed column above, with new order info
          this.displayList.unshift(column_rearranged[0])

          const fields_display_order = []
          this.displayList.forEach((element) => {
            //If all currecnt ag-grid column is inside the array of column to show given by backend then proceed else just skip
            const found = orders_info.find((x) => {
              return x.field_name === element.field_name
            })

            // If all the other column received from ag-grid is in array of column to show,
            //proceed and make a required payload for API call to save column re-arrangement information

            if (found) {
              //Adding new order returned by ag-grid for an element in a loop
              element.order = found.order - 1

              //Making required payload object form the API to save column re-arrangement
              //All the information is already in the is in array of column to show received from backend,
              //just found it and added it make payload object

              fields_display_order.push({
                fields_display_order_id: element.id,
                displayed: element.displayed,
                field_type: element.field_type,
                field_name: element.field_name,
                field_id: element.field_id,
                order: element.order,
                field_label: element.field_label,
                is_child: element.is_child,
                is_static: element.is_static,
                input_type: element.input_type
              })
            }
          })

          //Final payload object for re-arrangement API
          const payload = {
            fields_display_order,
            customer_id: this.$store.getters.customerId,
            from_list: '0',
            type: 'CRM',
            table_name: 'crm_list'
          }

          const allGridColumns = this.gridOptions.columnApi.getAllGridColumns()
          this.columnDefsBackup = allGridColumns.map((ele) => {
            return ele.colDef
          })

          //Finally calling API to save column by providing the payload generated from the above codes and logic
          this.rearrangeColumn(payload)
        } else {
        }
      }, 200)
    },

    async rearrangeColumn (payload) {
      try {
        const { data } = await arrangeColumn(payload)
      } catch (e) {
        console.error(e)
      }
    },

    handlefilterSidebar () {
      this.filterSidebarBoolean = !this.filterSidebarBoolean
      document.body.classList.add('overflow-hidden')
    },
    overallSearch () {
      this.overallSearchHolder = !this.overallSearchHolder
    }
  },
  computed: {
    rulesNumeric (check) {
      if (check === 'number') {
        return 'numeric'
      }
    },
    ...mapGetters([
      'get_leads_deleted_id',
      'get_leads_sidebar_view',
      'get_leads_sidebar_data',
      'get_leads_toggle_data'
    ]),
    isRowSelectable (rowNode) {
      return rowNode.data.is_active === '1'
    },
    limitedTableList () {
      //

      // const tableList = this.tableData.splice(0, this.pageLimitSet)
      return this.tableData
    },
    slectMulti () {
      const selectedNodes = this.gridApi
      if (selectedNodes) {
        return this.gridApi.getSelectedNodes
      }
      // return selectedNodes
    }
    // isRowSelected () {
    //   // const selectedNodes = this.gridApi.getSelectedNodes()

    // }
  },
  beforeRouteLeave (to, from, next) {
    this.addSideBar = false
    this.viewSideBar = false
    this.filterSidebar = false
    this.filterSidebarBoolean = false
    const viewleads = false
    this.SET_VIEW_LEADS_SIDEBAR(viewleads)
    this.SET_VIEW_LEADS_SIDEBAR_DATA(null)
    setTimeout(() => {
      next()
    }, 0)
  }
}
</script>
<style>
.vs-component .vs-dropdown--item,
.vs-dropdown--item-link,
.vs-dropdown--group-label,
.vs-component .vs-dropdown--group .marginIcon {
  font-weight: 500 !important;
}
.vs-sidebar-position-right {
  width: 375px !important;
  max-width: 400px !important;
  z-index: 111111111111111 !important;
  /*height: auto !important;*/
  /*position: absolute;*/
  /*top: 12%;*/
}

.flatpickr-calendar.open {
  z-index: 111111111111115 !important;
}

.vs-notifications {
  z-index: 1111111111111151111 !important;
}

.gb-vue-timeline-update__title {
  font-size: 14px !important;
  margin-left: -12px !important;
}

.gb-vue-timeline-update__ago {
  margin-right: -9%;
}
.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  box-shadow: 7px 3px 15px #c7c6c6;
}
/* .ag-header-cell {
    padding: 2px !important;
  } */

.custom-btn1 {
  padding: 5px 10px !important;
  font-size: 12px;
  border-radius: 0px;
  font-weight: 600;
}
.ag-pivot-off .ag-header-group-cell {
  /* font-size: 50px; */
  color: red;
}
.ag-grid-table {
  min-height: 250px;
}

li {
  list-style: none;
}
#selectdynamic {
  width: 100%;
  height: 38px;
  border-radius: 4px;
}
#dynamicradio {
  margin-right: 10px;
}

.requiredInput .vs-input--label:after {
  content: ' *';
  color: red;
}

.ag-theme-material .ag-ltr .ag-cell {
  display: flex;
  align-items: center;
}

.crm-record-table .con-vs-chip {
  max-width: unset;
}

.crm-record-table .con-vs-chip .text-chip {
  margin: unset;
}

.crm-record-table
  [col-id='tags']
  > div
  > span
  > span:nth-child(even)
  .con-vs-chip {
  background-color: #484866;
}

.crm-record-table [col-id='actionData'] {
  padding: 0;
}

.crm-record-table [col-id='actionData'] .vs-button {
  padding: 10px 4px !important;
}

.kanban_card_data > div.flex > span > span:nth-child(even) .con-vs-chip {
  background-color: #484866;
}

.kanban_card_data .con-vs-chip .text-chip {
  margin: unset;
}
</style>
